import { localStoragePath } from '../utils'
import { UPDATE_MUTED_WIDGETS } from '../constants'

import userLocalStorage from 'live/lib/user-local-storage'

export default (dashboardId, widgetId, muted) => dispatch => {
    userLocalStorage.setItem(localStoragePath(dashboardId, widgetId), muted)
    dispatch({ type: UPDATE_MUTED_WIDGETS, widgets: { [widgetId]: muted } })
}
